/*
 * @Description: axios二次封装
 * @Author: your name
 * @Date: 2019-05-24 14:53:55
 * @LastEditTime: 2019-06-13 14:39:15
 * @LastEditors: Please set LastEditors
 */
import axios from 'axios'
import { aesDecrypt, aesEncrypt } from '../utils/encrypt'
import { parseTime } from '../utils/parseTime'
import Router from '../../router/index'
// eslint-disable-next-line import/order
import { Notification } from 'element-ui'

// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
// eslint-disable-next-line
axios.defaults.baseURL = `${BASE_URL_CONFIG}${process.env.VUE_APP_PATH}`
axios.interceptors.request.use(
  config => {
    const sessionToken = sessionStorage.getItem('token') || ''
    const token = aesDecrypt(sessionToken, 'TOKEN') // 将后端返回的token解密
    if (!token) { // 判断用户是否已经登录
      Router.push({ path: '/login' })
    }
    // 设置请求头的一个token（将解密后的token和当前时间戳拼接在一起再进行加密）
    config.headers.xtoken = aesEncrypt(`${token},${parseTime(Date.now(), '{y}{m}{d}{h}{i}{s}')}`)
    // config.headers.xtoken =
    // 'SAkboNH2l1+7zrKSI5dgMa2Wnc3Cn1LFD2VWzUF+7oy8Rebv8fitasV4D5ao8V0QCwXtJP5nimUexooqnHunog=='
    return config
  },
  error => Promise.reject(error)
)

axios.interceptors.response.use(
  response => {
    // No permission
    if (response.headers.exceptioncode === '4') {
      Notification({
        title: '错误',
        message: '该页面没有权限,请联系管理员!',
        type: 'error',
        duration: 5 * 1000
      })
      Router.push({ path: '/index' })
      return ''
    }

    // Session time out
    if (response.headers.exceptioncode === '5') {
      sessionStorage.clear()
      Router.push({ path: '/login' })
    }
    return response
  },
  error => console.log('error =>', error)
)

export default axios
